export type CurrentWorkItem = {
  id: string;
  org: string;
  role?: string;
  title: string;
  summary: string;
  /**
   * "questions" rotates prompts; "cycle" steps through the sprint loop; "flow" shows data moving between systems;
   * "assemble" builds a page from print; "shifts" lists static from → to pairs; "report" grows a quick chart from a question
   */
  visual: "questions" | "cycle" | "flow" | "assemble" | "shifts" | "report";
  /** Spans the full row as the lead item */
  featured?: boolean;
  label: string;
  items: string[];
  /** Optional link to a related case study */
  href?: string;
};

export const currentWork: CurrentWorkItem[] = [
  {
    id: "search-social",
    org: "Lawrence University",
    role: "Organic Content & Social Media Strategy",
    title: "Making Search and Social Work Together",
    summary:
      "Building a more connected digital experience by aligning what audiences search for, what they see on social media, and how they experience a university online.",
    visual: "shifts",
    label: "What’s changing",
    href: "/work/lawrence-search-social",
    items: ["Search → Answers", "Social → Connection", "Website → Experience", "Strategy → Alignment"],
  },
  {
    id: "ai-governance",
    org: "Lawrence University",
    role: "Co-chair",
    title: "AI Governance Council",
    summary:
      "Building a shared, human-centered AI philosophy, a framework for decision-making and more for Lawrence University.",
    visual: "questions",
    label: "Asking first",
    href: "/work/lawrence-responsible-ai",
    items: [
      "Does AI need to be part of the solution?",
      "Who will experience it?",
      "Where does human judgment need to remain?",
      "What would make us stop?",
    ],
  },
  {
    id: "gdd-sprint-2",
    org: "Lawrence.edu",
    role: "Web product lead",
    title: "Growth-Driven Design, Sprint 2",
    summary: "Turning real post-launch behavior into the next focused release.",
    visual: "cycle",
    label: "The loop",
    items: ["Observe", "Prioritize", "Improve", "Measure"],
  },
  {
    id: "capital-campaign",
    org: "Lawrence University",
    role: "Web product lead",
    title: "A Capital Campaign Site",
    summary:
      "Using the campaign's branded print materials as the inspiration for its website, so donors get one cohesive experience from page to screen, and employing AI workflows to get there faster.",
    visual: "assemble",
    label: "Inspired by print",
    items: ["Branded print", "Web"],
  },
  {
    id: "brand-messaging",
    org: "Lawrence.edu",
    role: "Web product lead",
    title: "Branding & Messaging",
    summary:
      "Leading a branding and messaging exercise for the site, so every page tells Lawrence's story in one clear, consistent voice.",
    visual: "flow",
    label: "From brand to page",
    items: ["Brand", "Message", "Site"],
  },
  {
    id: "ga4-mcp",
    org: "Analytics + AI",
    role: "Builder",
    title: "A GA4 → Claude MCP",
    summary: "Connecting the Google Analytics 4 API to Claude so timely reporting takes a question, not a day.",
    visual: "report",
    label: "Ask, then answer",
    items: ["How did program pages do this week?"],
  },
];
